import { DifferentiationProps } from '@zola/zola-ui/src/components/PreAuthV3/Differentiation';
import { COLORS3 as COLORS } from '@zola/zola-ui/src/styles/emotion';
import NextBackgroundForegroundImages from 'components/PreauthV3/NextBackgroundForegroundImages';
import { differentiationStyleOverrides } from 'components/PreauthV3/NextBackgroundForegroundImages/NextBackgroundForegroundImages.styles';

// Foreground Images
const FreeSample = '/static-preauth/images/PaperLP/v3/Differentation/FreeSample.webp';
const GuestList = '/static-preauth/images/PaperLP/v3/Differentation/GuestList.webp';
const MatchingSuite = '/static-preauth/images/PaperLP/v3/Differentation/MatchingSuite.webp';
const SaveTheDate = '/static-preauth/images/PaperLP/v3/Differentation/SaveTheDate.webp';
const ThankYou = '/static-preauth/images/PaperLP/v3/Differentation/ThankYou.webp';

export const differentiationContent: DifferentiationProps['content'] = [
  {
    id: 'digital-save-the-dates',
    subtitle: 'Free digital save the dates for weddings',
    description:
      'Save time and stamps with free, customizable digital designs you can send in a snap.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.BAY_100}
        foregroundImg={{ src: SaveTheDate, alt: 'Save the date customization tools' }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'matching-suite',
    subtitle: 'Match your free wedding website',
    description:
      'Our invites and websites pair perfectly. Plus, with a QR code you can send guests straight to your website.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.FOREST_100}
        foregroundImg={{
          src: MatchingSuite,
          alt: 'Save the date paper design and matching wedding website',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'guest-list-manager',
    subtitle: 'Free guest list manager',
    description:
      'Grab guest info in one go with Contact Collector, while we track everything for you — RSVPs, plus ones, and meal choices.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.COVE_100}
        foregroundImg={{
          src: GuestList,
          alt: 'Guest list manager and adressed envelopes',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'writing-tips',
    subtitle: 'Tips for what to write and when to send invitations',
    description:
      'Not sure when to send your invites? Need to brush up on your addressing etiquette? Don’t worry, we’ve got you covered.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.ROSE_100}
        foregroundImg={{
          src: ThankYou,
          alt: 'Not sure what to write? Select options for thank you notes',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'free-samples',
    subtitle: 'Free samples and free guest addressing',
    description:
      'See your invites IRL before you place an order. Once you’ve decided, we’ll make the whole process simple.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.MARINE_100}
        foregroundImg={{
          src: FreeSample,
          alt: 'Free samples and free guest addressing',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
];
